export const msalConfig = {
  auth: {
    clientId: "30a59cc1-88c9-4f5f-abbc-4d20345899c8",
    authority: "https://login.microsoftonline.com/common", 
    redirectUri: "https://portal.rapidresourcingltd.co.uk/ms/mail/callbaclk",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ["Mail.Read", "Mail.Send"],
};
